import { padStart } from "lodash";
import { addYears, stripToDay } from "../utils/date";

export class DateHelper {
    public static monthsInAYear = 12;
    public static taxYearEndMonth = 4;
    public static taxYearEndDay = 6;
    public static months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    public static getRemainingMonthsToYearEnd(): number {
        return this.monthsInAYear - this.getCurrentMonth();
    }

    public static getRemainingMonthsToTaxYearEnd(): number {
        const currentDate = new Date(new Date().toDateString());
        const taxYearDate = this.getTaxYearDate();
        const currentMonth = this.getCurrentMonth();

        if (currentDate > taxYearDate && currentMonth >= this.taxYearEndMonth) {
            return this.taxYearEndMonth + this.monthsInAYear - currentMonth;
        }

        if (currentDate <= taxYearDate && currentMonth === this.taxYearEndMonth) {
            return 1;
        }

        return this.taxYearEndMonth - currentMonth;
    }

    public static getTaxYearDate(): Date {
        const currentMonth = this.getCurrentMonth();
        const currentDay = this.getCurrentDay();
        const currentYear = this.getCurrentYear();

        if (currentMonth >= 1 && currentMonth < this.taxYearEndMonth && currentDay < this.taxYearEndDay) {
            return new Date(currentYear - 1, this.taxYearEndMonth - 1, this.taxYearEndDay);
        }

        return new Date(currentYear, this.taxYearEndMonth - 1, this.taxYearEndDay);
    }

    public static getCurrentMonth(): number {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;

        return currentMonth;
    }

    public static getCurrentYear(): number {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        return currentYear;
    }

    public static getCurrentDay(): number {
        const currentDate = new Date();
        const currentDay = currentDate.getDate();

        return currentDay;
    }

    public static addMonths(date: Date, howMany: number): Date {
        const d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + howMany, 1);
        const m = date.getMonth();
        date.setDate(d);

        if (date.getMonth() !== m) {
            date.setDate(0);
        }

        return date;
    }

    public static getYearTwoDigits(date: Date): string {
        const year = date.getFullYear().toString();

        return year.substring(year.length - 2);
    }

    public static getNumberOfDayString(numberOfDay: number): string {
        switch (numberOfDay) {
            case 31:
            case 1:
            case 21:
                return numberOfDay + "st";
            case 2:
            case 22:
                return numberOfDay + "nd";
            case 3:
            case 23:
                return numberOfDay + "rd";
            default:
                return numberOfDay + "th";
        }
    }

    public static getTomorrow(): Date {
        const today: Date = new Date();
        const tomorrow: Date = new Date();
        tomorrow.setDate(today.getDate() + 1);
        return DateHelper.getDatePortion(tomorrow);
    }

    public static getDatePortion(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    public static getFutureDate(daysInFuture: number): Date {
        const today: Date = new Date();
        const futureDate: Date = new Date();
        futureDate.setDate(today.getDate() + daysInFuture);
        return futureDate;
    }

    public static getDayDifference(date1: Date, date2: Date): number {
        const diffDays = Math.floor(
            (Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()) -
                Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())) /
                (1000 * 60 * 60 * 24)
        );
        return diffDays;
    }

    public static getMonthDifference(endDate: Date, startDate: Date): number {
        return (
            (endDate.getFullYear() - startDate.getFullYear()) * 12 +
            (endDate.getMonth() - startDate.getMonth()) +
            (endDate.getDate() >= startDate.getDate() ? 0 : -1)
        );
    }

    public static getDateStringAsddmmmyyyy(date: Date, shortenMonths?: boolean): string {
        let month = this.months[date.getMonth()];
        if (shortenMonths) {month = month.slice(0, 3);}

        const day = padStart(date.getDate().toString(), 2, "0");

        const formattedDate = day + " " + month + " " + date.getFullYear();
        return formattedDate;
    }

    public static getDateStringAsyyyymmdd(date: Date): string {
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
    
        return `${year}-${month}-${day}`;
    }

    public static getDateStringAsddmmm(date: Date, shortenMonths?: boolean): string {
        let month = this.months[date.getMonth()];
        if (!!shortenMonths) month = month.slice(0, 3);

        const day = padStart(date.getDate().toString(), 2, "0");

        let formattedDate = day + " " + month;
        return formattedDate;
    }

    public static toStartOfDay(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return date;
    }

    public static toEndOfDay(date: Date): Date {
        date.setHours(23, 59, 59, 999);
        return date;
    }

    public static yearFromNow = () => {
        const result = stripToDay(addYears(new Date(Date.now()), 1));
        if (result.getDate() > 28) {
            result.setDate(28);
        }
        return result;
    };
}
